import { Avatar } from "@mui/material";
import React from "react";

const CustomerWidget = ({ value }) => {
  return value ? (
    <div className="flex g-15 a-center mb-5 mt-5">
      <Avatar className="bg-primary" src={value.photo || ""}>
        {(value.firstName + value.lastName).substring(0, 2)}
      </Avatar>
      <div className="grid">
        <span className="">{value.firstName + " " + value.lastName}</span>
        <div className="flex gap-1 items-center">
          <span className="fs-12">{value.cstmrCode}</span>
          {value.email && (
            <>
              | <span className="fs-12">{value.email}</span>
            </>
          )}{" "}
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

export default CustomerWidget;
